import Snackbar from "@mui/material/Snackbar";
import { Alert, styled, Typography } from "@mui/material";

const StyleSnackbar = styled(Snackbar)`
  user-select: none;
`;

const InfoSnackbar = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration,
  anchorOrigin,
}) => {
  const handleClose = (event, reason) => onClose(event, reason);

  return (
    <StyleSnackbar
      open={open}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <Alert
        variant="filled"
        severity={severity}
      >
        <Typography variant="body1">
          {message}
        </Typography>
      </Alert>
    </StyleSnackbar>
  );
};

export default InfoSnackbar;
